import { ReactElement } from 'react'
import { Button, Grid, Text } from '@raskrask-dk/rr-components'
import { StyledPaymentMethods } from './styles'
import { useTranslation } from 'react-i18next'
import { PropsPaymentMethodsTemplate } from './props'

const PaymentMethodsTemplate = ({
    onClickPaymentMethod,
    paymentMethods,
    selectedPaymentMethod,
}: PropsPaymentMethodsTemplate): ReactElement => {
    const { t } = useTranslation()

    const paymentMethodsWrapper = (
        <StyledPaymentMethods>
            <Grid gap={16} autoFlow="column">
                {paymentMethods.map((method, key) => (
                    <Button
                        active={method === selectedPaymentMethod}
                        data-cy={`Payment_method_${key + 1}`}
                        key={key}
                        onClick={() => onClickPaymentMethod(method)}
                        variant="option"
                    >
                        {t(`checkout.paymentmethods.${method}`)}
                    </Button>
                ))}
            </Grid>
        </StyledPaymentMethods>
    )

    return (
        <Grid gap={4}>
            <Text bold primary>
                {t('checkout.paymentmethod.header')}
            </Text>
            {paymentMethodsWrapper}
        </Grid>
    )
}

export default PaymentMethodsTemplate
